// Configuración de la interna (lo que atomic-crm llama "configuration"), en español.
// Sin alias "@/" ni import de .svg: este archivo también lo leen scripts de Node (tsx) y tsc suelto.
import type { ConfigurationContextValue } from "../components/atomic-crm/root/ConfigurationContext";

/** Logo provisional (el definitivo lo decide Rocío en marca/). Mismo dibujo que logo-agencia.svg. */
const logo =
  "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2032%2032%22%20width%3D%2232%22%20height%3D%2232%22%3E%3Crect%20width%3D%2232%22%20height%3D%2232%22%20rx%3D%228%22%20fill%3D%22%232E57C9%22/%3E%3Ccircle%20cx%3D%2212%22%20cy%3D%2213%22%20r%3D%224%22%20fill%3D%22%23fff%22/%3E%3Cpath%20d%3D%22M5%2025c0-4%203.2-6.5%207-6.5s7%202.5%207%206.5%22%20fill%3D%22%23fff%22/%3E%3Cpath%20d%3D%22M19.5%2014.5l2.5%202.5%205-5.5%22%20stroke%3D%22%233DC488%22%20stroke-width%3D%222.6%22%20fill%3D%22none%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3C/svg%3E";

export const ETAPAS_PROSPECTO = [
  { value: "nuevo", label: "Nuevo" },
  { value: "calificando", label: "Calificando" },
  { value: "en-cierre", label: "En cierre" },
  { value: "cerrado", label: "Cerrado" },
  { value: "perdido", label: "Perdido" },
];

export const configuracionAgencia: ConfigurationContextValue = {
  title: "Agencia de reclutamiento",
  currency: "MXN",
  dealStages: ETAPAS_PROSPECTO,
  dealPipelineStatuses: ["cerrado"],
  dealCategories: [
    { value: "reclutamiento", label: "Reclutamiento" },
    { value: "otro", label: "Otro" },
  ],
  companySectors: [
    { value: "automotriz", label: "Automotriz y refacciones" },
    { value: "comercializadora", label: "Comercializadora" },
    { value: "distribucion", label: "Distribución y logística" },
    { value: "industria", label: "Industria" },
    { value: "servicios", label: "Servicios" },
    { value: "otro", label: "Otro" },
  ],
  noteStatuses: [
    { value: "frio", label: "Frío", color: "#7dbde8" },
    { value: "tibio", label: "Tibio", color: "#e8cb7d" },
    { value: "caliente", label: "Caliente", color: "#e88b7d" },
    { value: "contrato", label: "Con contrato", color: "#a4e87d" },
  ],
  taskTypes: [
    { value: "ninguno", label: "Ninguno" },
    { value: "llamada", label: "Llamada" },
    { value: "whatsapp", label: "WhatsApp" },
    { value: "correo", label: "Correo" },
    { value: "junta", label: "Junta" },
    { value: "seguimiento", label: "Seguimiento" },
    { value: "propuesta", label: "Mandar propuesta" },
  ],
  darkModeLogo: logo,
  lightModeLogo: logo,
};
